import { render, staticRenderFns } from "./package-compare.vue?vue&type=template&id=01b60506&scoped=true"
import script from "./package-compare.vue?vue&type=script&lang=ts"
export * from "./package-compare.vue?vue&type=script&lang=ts"
import style0 from "./package-compare.vue?vue&type=style&index=0&id=01b60506&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b60506",
  null
  
)

export default component.exports